// Staff Vuex

import state from './staffStates.js'
import * as getters from './staffGetters.js'
import * as mutations from './staffMutations.js'
import * as actions from './staffActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
